"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthConsumer = exports.REFRESHING_KEY = exports.VERIFIER_KEY = exports.STATE_KEY = exports.REFRESH_TOKEN_KEY = exports.TOKEN_KEY = void 0;
var axios_1 = __importDefault(require("axios"));
var jsonwebtoken_1 = __importDefault(require("jsonwebtoken"));
var helpers = __importStar(require("./helpers"));
var LocalStore_1 = require("./LocalStore");
exports.TOKEN_KEY = '@@token';
exports.REFRESH_TOKEN_KEY = '@@rtoken';
exports.STATE_KEY = '@@pkce_state';
exports.VERIFIER_KEY = '@@pkce_code_verifier';
exports.REFRESHING_KEY = '@@tknrefresh';
var AuthConsumer = /** @class */ (function () {
    function AuthConsumer(opts) {
        var _a;
        this.clientId = opts.clientId;
        this.providerHost = opts.providerHost;
        this.axiosClient = opts.axiosClient || axios_1.default.create();
        this.withCredentials = opts.withCredentials !== undefined ? opts.withCredentials : true;
        this.store = opts.store || new LocalStore_1.LocalStore();
        this.getCurrentUri = opts.getCurrentUri || helpers.currentUri;
        this.navigate = opts.navigate || helpers.navigate;
        this.parseQuery = opts.parseQuery || helpers.parseQuery;
        this.crypto = opts.crypto || window.crypto;
        this.tokenExpiration = null;
        this.gracePeriod = (_a = opts.gracePeriod) !== null && _a !== void 0 ? _a : Date.now() + 30000;
    }
    AuthConsumer.prototype.getClientId = function () {
        return this.clientId;
    };
    AuthConsumer.prototype.getProviderHost = function () {
        return this.providerHost;
    };
    AuthConsumer.prototype.getTokens = function () {
        return __awaiter(this, void 0, void 0, function () {
            var accessToken, refreshToken, isRefreshing;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.store.getValue(exports.TOKEN_KEY)];
                    case 1:
                        accessToken = _a.sent();
                        return [4 /*yield*/, this.store.getValue(exports.REFRESH_TOKEN_KEY)];
                    case 2:
                        refreshToken = _a.sent();
                        return [4 /*yield*/, this.store.getValue(exports.REFRESHING_KEY)];
                    case 3:
                        isRefreshing = _a.sent();
                        if (accessToken && refreshToken) {
                            // set token expiration if null
                            if (!this.tokenExpiration) {
                                this.setTokenExpiration(accessToken);
                            }
                            return [2 /*return*/, {
                                    accessToken: accessToken,
                                    refreshToken: refreshToken,
                                }];
                        }
                        return [2 /*return*/, null];
                }
            });
        });
    };
    AuthConsumer.prototype.getAccessToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.store.getValue(exports.TOKEN_KEY)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    AuthConsumer.prototype.subscribeToKey = function (key, cb) {
        return this.store.subscribe(key, cb);
    };
    AuthConsumer.prototype.isExpired = function () {
        if (this.tokenExpiration) {
            return this.tokenExpiration < Date.now();
        }
        return false;
    };
    AuthConsumer.prototype.isExpiring = function () {
        if (this.tokenExpiration) {
            // check if expiring within grace period (30 seconds)
            return !this.isExpired() && this.tokenExpiration < this.gracePeriod;
        }
        return false;
    };
    AuthConsumer.prototype.isTokenExpired = function (token) {
        return jsonwebtoken_1.default.decode(token).exp * 1000 < Date.now();
    };
    AuthConsumer.prototype.getParsedQuery = function () {
        return this.parseQuery();
    };
    AuthConsumer.prototype.getLoginUri = function (redirectUri) {
        return __awaiter(this, void 0, void 0, function () {
            var state, codeVerifier, codeChallenge, params;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        state = this.generateRandomString();
                        return [4 /*yield*/, this.store.setValue(exports.STATE_KEY, state)];
                    case 1:
                        _a.sent();
                        codeVerifier = this.generateRandomString();
                        return [4 /*yield*/, this.store.setValue(exports.VERIFIER_KEY, codeVerifier)];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.pkceChallengeFromVerifier(codeVerifier)];
                    case 3:
                        codeChallenge = _a.sent();
                        params = new URLSearchParams({
                            client_id: this.clientId,
                            redirect_uri: redirectUri,
                            state: state,
                            code_challenge: codeChallenge,
                        });
                        return [2 /*return*/, this.getProviderLoginUri() + "?" + params.toString()];
                }
            });
        });
    };
    AuthConsumer.prototype.createTokens = function (code, authState) {
        return __awaiter(this, void 0, void 0, function () {
            var state, codeVerifier, response, _a, accessToken, refreshToken, newTokens;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        state = this.store.getValue(exports.STATE_KEY);
                        codeVerifier = this.store.getValue(exports.VERIFIER_KEY);
                        if (state !== authState) {
                            throw new Error('returned auth state does not match stored pkce state');
                        }
                        return [4 /*yield*/, this.axiosClient.post(this.getProviderTokenUri(), {
                                client_id: this.clientId,
                                redirect_uri: this.getCurrentUri(),
                                code: code,
                                code_verifier: codeVerifier,
                            }, {
                                crossDomain: true,
                                withCredentials: this.withCredentials,
                            })];
                    case 1:
                        response = _b.sent();
                        return [4 /*yield*/, this.challengeCleanup()];
                    case 2:
                        _b.sent();
                        _a = response.data, accessToken = _a.token, refreshToken = _a.refresh_token;
                        newTokens = {
                            accessToken: accessToken,
                            refreshToken: refreshToken,
                        };
                        return [4 /*yield*/, this.storeTokens(newTokens)];
                    case 3:
                        _b.sent();
                        return [2 /*return*/, newTokens];
                }
            });
        });
    };
    AuthConsumer.prototype.getRefreshTokens = function (tokens) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axiosClient.post(this.getProviderRefreshTokenUri(), {
                            client_id: this.clientId,
                            refresh_token: tokens.refreshToken,
                        }, {
                            crossDomain: true,
                            withCredentials: this.withCredentials,
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    AuthConsumer.prototype.refreshTokens = function (tokens) {
        return __awaiter(this, void 0, void 0, function () {
            var response, _a, accessToken, refreshToken, newTokens;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.getRefreshTokens(tokens)];
                    case 1:
                        response = _b.sent();
                        _a = response.data, accessToken = _a.token, refreshToken = _a.refresh_token;
                        newTokens = {
                            accessToken: accessToken,
                            refreshToken: refreshToken,
                        };
                        return [4 /*yield*/, this.storeTokens(newTokens)];
                    case 2:
                        _b.sent();
                        return [2 /*return*/, newTokens];
                }
            });
        });
    };
    AuthConsumer.prototype.storeTokens = function (tokens) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.store.setValue(exports.TOKEN_KEY, tokens.accessToken)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.store.setValue(exports.REFRESH_TOKEN_KEY, tokens.refreshToken)];
                    case 2:
                        _a.sent();
                        this.setTokenExpiration(tokens.accessToken);
                        return [2 /*return*/];
                }
            });
        });
    };
    AuthConsumer.prototype.endSession = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.store.clearValue(exports.TOKEN_KEY)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.store.clearValue(exports.REFRESH_TOKEN_KEY)];
                    case 2:
                        _a.sent();
                        this.tokenExpiration = null;
                        return [2 /*return*/];
                }
            });
        });
    };
    AuthConsumer.prototype.setTokenExpiration = function (token) {
        this.tokenExpiration = jsonwebtoken_1.default.decode(token).exp * 1000;
    };
    AuthConsumer.prototype.challengeCleanup = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.store.clearValue(exports.STATE_KEY)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.store.clearValue(exports.VERIFIER_KEY)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    AuthConsumer.prototype.getProviderLoginUri = function () {
        return this.providerHost;
    };
    AuthConsumer.prototype.getProviderTokenUri = function () {
        return this.providerHost + "/auth/token";
    };
    AuthConsumer.prototype.getProviderRefreshTokenUri = function () {
        return this.providerHost + "/auth/token/refresh";
    };
    AuthConsumer.prototype.generateRandomString = function () {
        return helpers.generateRandomString(this.crypto);
    };
    AuthConsumer.prototype.pkceChallengeFromVerifier = function (v) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, helpers.pkceChallengeFromVerifier(this.crypto, v)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return AuthConsumer;
}());
exports.AuthConsumer = AuthConsumer;
